import { HTMLAttributeAnchorTarget } from 'react';
import { Nullable, FileObj } from '~globals/types';
import { uniqueId } from 'lodash';

export const openFileUrl = (
  url: string,
  target: HTMLAttributeAnchorTarget = '_blank',
): Nullable<Window> => window.open(url, target);

export const createObjFileBlob = (file: File, name = 'file'): FileObj => ({
  id: uniqueId(`${name}-`),
  file,
});
